import clsx from "clsx";
import { useEffect, useState } from "react";

import { Product } from "@transfr-inc/dashboard-components/constants";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { ChartFilter } from "@components/custom/forms";
import { TopCareersSelected } from "@components/top-careers-selected";
import { useDateStore } from "@src/stores/zustand/date-store";
import { DashboardChart } from "./dashboard.chart";
import { TrekDataboxes } from "./trek.databoxes";

export function TrekInsights({
  userInfo,
  orgCode,
  generalStats,
  dailyStats,
  onApplyFilters,
  classroomFilterEnabled,
  organizationEnabled,
  className,
  topCareers,
  isLoadingTopCareers,
  users,
  onExportData,
  exportDataDisabled,
}) {
  const [categorySelected, setCategorySelected] = useState();
  const lastDateFilter = useDateStore((state) => state.lastDateFilter);
  const [dateFilter, setDateFilter] = useState(lastDateFilter);
  const [allTimeStartDate, setAllTimeStartDate] = useState();
  const [truncatedDailyStats, setTruncatedDailyStats] = useState(dailyStats);

  useEffect(() => {
    setTruncatedDailyStats(dailyStats);
    if (!dailyStats.isLoading && dateFilter > 365) {
      let firstDataIndex = dailyStats.response.findIndex(
        (item) => Object.keys(item).length > 2
      );
      firstDataIndex = firstDataIndex == -1 ? 0 : firstDataIndex;
      const truncated = dailyStats.response.slice(firstDataIndex);

      setTruncatedDailyStats({
        ...dailyStats,
        response: truncated,
      });
      setAllTimeStartDate(truncated[0].date);
    }
  }, [dailyStats, dateFilter]);

  const onToggleAllTime = (allTimeSelected) => {
    if (allTimeSelected) {
      setDateFilter(366);
    } else {
      setDateFilter();
      setAllTimeStartDate();
    }
  };

  return (
    <div className={clsx("dashboard-insights", className)}>
      <div className="subheader">
        <ChartFilter
          onApplyFilters={onApplyFilters}
          userInfo={userInfo}
          orgCode={orgCode}
          classroomEnabled={classroomFilterEnabled}
          organizationEnabled={organizationEnabled}
          product={Product.TRK}
          allTimeStartDate={allTimeStartDate}
          onToggleAllTime={onToggleAllTime}
        />
        <div className="right-hand-buttons">
          <Button
            primary
            size="small"
            icon={["fa-light", "file-export"]}
            onClick={onExportData}
            disabled={exportDataDisabled}
          >
            Export Data
          </Button>
        </div>
      </div>
      <TopCareersSelected
        breadcrumbLabel="dashboard"
        topCareers={topCareers}
        isLoading={isLoadingTopCareers}
        activeUsers={generalStats?.totalActiveUsers}
        users={users}
      />
      <TrekDataboxes
        onCategoryChange={setCategorySelected}
        data={generalStats}
      />
      <DashboardChart
        className="chart"
        dailyStats={truncatedDailyStats}
        filterSelected={categorySelected}
      />
    </div>
  );
}
